<template>
    <b-container fluid id="sidebar" class="noMargin noPadding">
        <template v-for="(item, index) in navItems" v-if="$store.getters.isAuth">
            <b-row class="">
                <b-col cols="12" :class="[currentPage.startsWith(item.href) ? activeClass : 'routerLink', 'py-2']">
                    <b-row class="flex-center p-2">
                        <b-col cols="2" offset="1">
                            <span :class="item.icon + ' fa-2x px-2 justify-content-between mx-2'"></span>
                        </b-col>
                        <b-col cols="9">
                            <router-link :to="item.href"
                             v-b-toggle="'collapse' + item.title"
                             class="d-flex text-left px-2">
                                <div class="align-items-left text-left">
                                    
                                    {{ $t(item.title)}}
                                </div>
                    </router-link>
                        </b-col>
                    </b-row>
                    

                </b-col>
            </b-row>
                
                <b-collapse accordion="my-accordion" :id="'collapse' + item.title">
                    <ul v-if="item.submenuItems" class="list-unstyled">
                        <li v-for="sub in item.submenuItems" class="submenu-link">
                            <router-link
                                    :to="sub.href"
                                    v-b-toggle="'collapse' + sub.title"
                                    class="ml-2">
                                {{ sub.title }}
                            </router-link>
                            <b-collapse accordion="my-accordion2" :id="'collapse' + sub.title">
                                <ul v-if="sub.submenuItems" class="list-unstyled">
                                    <li v-for="subsub in sub.submenuItems" class="submenu-link">
                                        <router-link
                                                :to="subsub.href"
                                                class="ml-3">
                                            {{ subsub.title }}
                                        </router-link>
                                    </li>
                                </ul>
                            </b-collapse>
                        </li>
                    </ul>
                </b-collapse>
            <div v-if="index < navItems.length - 1" class="separator"></div>
        </template>
    </b-container>
</template>
<script>
    export default {
        name: 'sidebar',
        props: {
            items: {
                type: Object,
                default: null
            }
        },
        computed: {
            navItems() {
                if (this.$parent.currentUser) {
                    switch (this.$parent.currentUser.role) {
                        case 'administrator':
                            return this.items.admin;
                        case 'sales':
                            return this.items.sales;
                        case 'guest':
                            return this.items.guest;

                    }
                }
            },
            currentPage(){
                return this.$route.path;
            }
        },
        data() {
            return {
                activeClass: 'active',
            }
        },
        created() {
        },
        methods: {
            logout() {
                this.$router.push('/auth/login');
            },
        },
        destroyed(){
            clearInterval(this.interval);
        },
    }
</script>
<style lang="scss"> 
    @media screen and (max-width: 1024px) {
        #sidebar {
            visibility: hidden;
            clear: both;
            float: left;
            margin: 10px auto 5px 20px;
            width: 28%;
            display: none;
        }
    }
    #sidebar {
        width: 100%;       

    }
    .sidebar {
        .dropdown-menu {
            padding: 8px 16px;
        }
    }


    .sidebar-link {
        font-size: 1em !important;
        min-width: 50px;
    }

    .submenu-link {
        font-size: 0.9em !important;
    }

    .sidebar-link, .submenu-link {
        margin: 8px 0;
        a {
            padding: 5px 5px;
            color: #FFF!important;
        }
        a.active {
            font-weight: 700;
            text-decoration: underline;
        }
    }

    .separator{
        height: 1px;
        background: rgb(219, 217, 217);
        margin: 0 0px;
    }


    .active{
        color: #FFF !important;
        //background: #007bff !important;
        background-image: linear-gradient( 108deg,  rgba(2,93,145,1) 17.3%, rgba(0,156,222,1) 77.6% ) !important;
        
        a{
            color: #FFF !important;
        }
    }

</style>